// _header-desktop.js
// prettier really wants the semicolon to be there...
// eslint-disable-next-line no-extra-semi
;(() => {
  const header = document.querySelector('header.-desktop')
  if (!header) return

  // Toggle buttons
  const burgerToggle = header.querySelector('.menu-item--burger-toggle')
  const profileToggle = header.querySelector('.menu-item--profile-toggle')
  const phoneButton = header.querySelector('.menu-item--phone')
  const topNavItems = header.querySelectorAll('.top-nav > .menu-item')
  const sideNavItems = header.querySelectorAll('.side-nav > .menu-item')
  const navItems = [...topNavItems, ...sideNavItems]
  const submenuToggles = header.querySelectorAll('.menu-item__submenu-toggle')

  // Sticky header
  document.addEventListener('scroll', () => {
    header.classList.toggle('is-sticky', window.scrollY > 100)
  })

  // Helper to wire up a toggle button + panel + parent <li>
  function wireToggle(button) {
    const panel = document.getElementById(button.getAttribute('aria-controls'))
    const listItem = button.closest('li.menu-item')

    button.addEventListener('click', () => {
      const willOpen = button.getAttribute('aria-expanded') === 'false'

      // ARIA state
      button.setAttribute('aria-expanded', String(willOpen))
      // show/hide via hidden attr
      if (willOpen) {
        panel.removeAttribute('hidden')
      } else {
        panel.setAttribute('hidden', '')
      }
      // CSS animation class
      panel.classList.toggle('open', willOpen)
      // header hovered shadow
      header.classList.toggle('is-hovered', willOpen)
      // parent <li> active class
      listItem.classList.toggle('active', willOpen)
    })
  }

  if (profileToggle) wireToggle(profileToggle)
  if (burgerToggle) wireToggle(burgerToggle)

  function closeAllSubmenus() {
    submenuToggles.forEach(toggle => {
      const li = toggle.closest('.menu-item')
      li.classList.remove('is-submenu-open')
      toggle.setAttribute('aria-expanded', 'false')
    })
  }

  submenuToggles.forEach(toggle => {
    toggle.addEventListener('click', e => {
      e.preventDefault()
      e.stopPropagation()
      const li = toggle.closest('.menu-item')
      const willOpen = !li.classList.contains('is-submenu-open')
      closeAllSubmenus()
      if (willOpen) {
        li.classList.add('is-submenu-open')
        toggle.setAttribute('aria-expanded', 'true')
      }
    })
    toggle.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
        const li = toggle.closest('.menu-item')
        li.classList.remove('is-submenu-open')
        toggle.setAttribute('aria-expanded', 'false')
        toggle.focus()
      }
    })
  })

  // Close dropdowns & remove .active when hovering other nav items
  navItems.forEach(item => {
    item.addEventListener('mouseenter', () => {
      closeAllSubmenus()
      if (profileToggle && !item.classList.contains('menu-item--profile')) {
        profileToggle.setAttribute('aria-expanded', 'false')
        const pm = document.getElementById(
          profileToggle.getAttribute('aria-controls')
        )
        pm.setAttribute('hidden', '')
        pm.classList.remove('open')
        profileToggle.closest('li.menu-item').classList.remove('active')
      }
      if (burgerToggle && !item.classList.contains('menu-item--burger')) {
        burgerToggle.setAttribute('aria-expanded', 'false')
        const mm = document.getElementById(
          burgerToggle.getAttribute('aria-controls')
        )
        mm.setAttribute('hidden', '')
        mm.classList.remove('open')
        burgerToggle.closest('li.menu-item').classList.remove('active')
        header.classList.remove('is-hovered')
      }
    })
  })

  // Hover shadow for top-nav items
  topNavItems.forEach(item => {
    item.addEventListener('mouseenter', () =>
      header.classList.add('is-hovered')
    )
    item.addEventListener('mouseleave', () =>
      header.classList.remove('is-hovered')
    )
  })

  // Hide all on mouse leave, removing .active
  header.addEventListener('mouseleave', () => {
    closeAllSubmenus()
    if (profileToggle) {
      profileToggle.setAttribute('aria-expanded', 'false')
      const pm = document.getElementById(
        profileToggle.getAttribute('aria-controls')
      )
      pm.setAttribute('hidden', '')
      pm.classList.remove('open')
      profileToggle.closest('li.menu-item').classList.remove('active')
    }
    if (burgerToggle) {
      burgerToggle.setAttribute('aria-expanded', 'false')
      const mm = document.getElementById(
        burgerToggle.getAttribute('aria-controls')
      )
      mm.setAttribute('hidden', '')
      mm.classList.remove('open')
      burgerToggle.closest('li.menu-item').classList.remove('active')
    }
    header.classList.remove('is-hovered')
  })

  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return
    if (
      submenuToggles.length &&
      document.querySelector('.menu-item.is-submenu-open')
    ) {
      closeAllSubmenus()
    }
  })

  // Phone tooltip (mouse + keyboard focus)
  if (phoneButton) {
    phoneButton.addEventListener('mouseenter', () =>
      phoneButton.classList.add('modal-show')
    )
    phoneButton.addEventListener('mouseleave', () =>
      phoneButton.classList.remove('modal-show')
    )
    phoneButton.addEventListener('focusin', () =>
      phoneButton.classList.add('modal-show')
    )
    phoneButton.addEventListener('focusout', () =>
      phoneButton.classList.remove('modal-show')
    )
  }
})()
